interface ICdnData {
	domains: Record<string, string>;
	main: {
		home: string;
		cdn: string;
	}
}

export class CDNHandler {
	private _data: ICdnData;

	public async getCdnDomain(): Promise<string> {
		if (typeof this._data === 'undefined') {
			const response = await fetch('/cdn.json');
			this._data = await response.json();
		}

		const domain = window.location.hostname;

		Object.keys(this._data.domains).forEach(regex => {
			const test = new RegExp(regex, 'g');
			if (test.exec(domain) !== null) {
				return this._data.domains[regex];
			}
		})

		return this._data.main.cdn;
	}
}
